import { get } from 'common';

const ABOUTUS_ROUTE = `${process.env.REACT_APP_API_CONFIG}about-us`;


export class AboutUsService {
    private static instance: AboutUsService;

    static getInstance(): AboutUsService {
        if (!this.instance) {
            this.instance = new AboutUsService();
        }

        return this.instance;
    }

    async findAll() {
        return await get(`${ABOUTUS_ROUTE}/`);
    }

    async findOne(id: number) {
        return await get(`${ABOUTUS_ROUTE}/${id}`);
    }
}
